import React from 'react';
import TransfersPage from './TransfersPage';

function SalesPage() {
  return (
    <TransfersPage
      mode="sales"
      pageTitle="Sales"
    />
  );
}

export default SalesPage;
